<template>
  <div id="wrapper" class="noheader">
    <div class="content">
      <div class="caption">
        <div class="inner">
          <span></span>
          <p>木生婦幼診所</p>
          <span></span>
        </div>
        <a
          v-if="$store.state.from === '/FeedBack'"
          @click="backHome"
          class="arr"
          ><div class="inner"></div
        ></a>
      </div>
      <div class="surveyBox">
        <div class="title">
          <h2 style="text-align: center;">
            顧客滿意度調查
          </h2>
        </div>
        <p style="color: #999999; text-align: justify;">
          親愛的患者您好:
          <br />
          本院為提供更友善專業的醫療服務環境，懇請您利用幾分鐘的時間，填寫這份問卷。為保護您的權益，本問卷將由專人處理，問卷內容均予保密。
          <br />
          您的反饋是我們進步的動力，若您需要即刻地改善，請寫下姓名與電話，並請提供建議或改善事項，我們會盡快處理，感謝您的指教與支持。
        </p>
        <br />
        <div class="formBox">
          <form action="javascript:void(0);">
            <h3 style="text-align: center;">
              住院背景
            </h3>
            <br />
            <p style="display:inline;">
              請問您是初次來本診所住院嗎？
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <br />
            <select v-model="survey['初次住院']">
              <option value="">請選擇下列選項</option>
              <option value="是">是</option>
              <option value="否">否</option>
            </select>
            <p style="display:inline;">
              請問您(就醫者)此次看診科別為？
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <br />
            <select v-model="survey['看診科別']">
              <option value="">請選擇下列選項</option>
              <option value="婦科">婦科</option>
              <option value="產科">產科</option>
            </select>
            <br />
            <div>
              <p style="display:inline;">
                請問您(就醫者)今日看診醫師為
              </p>
              <p style="color: red; display:inline-block;">（必填）</p>
            </div>
            <br />
            <input
              v-model="survey['看診醫師']"
              type="text"
              class="inputBox line"
            />
            <p style="display:inline;">
              請問您此次入住的病房號碼為
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <select v-model="survey['病房號碼']">
              <option value="">請選擇下列選項</option>
              <option value="501">501</option>
              <option value="502">502</option>
              <option value="503">503</option>
              <option value="504">504</option>
              <option value="505">505</option>
              <option value="506">506</option>
              <option value="507">507</option>
              <option value="321">321</option>
              <option value="322">322</option>
              <option value="323">323</option>
              <option value="其他">其他</option>
            </select>
            <br />
            <h3 style="text-align: center;">
              診所醫療設施與病房服務
            </h3>
            <br />
            <div
              v-for="(questionSet, number) in satisfactoinQuestion"
              :key="number"
            >
              <b>
                {{ satisfactoinTitle[number] }}
              </b>
              <b style="color: red;" v-if="number !== 0">（必填）</b>
              <br />
              <br />
              <div v-for="question in questionSet" :key="question">
                <p style="color: #999999;">
                  {{ question }}
                </p>
                <br />
                <select v-model="survey[question]">
                  <option value="">請選擇下列選項</option>
                  <option value="滿意">滿意</option>
                  <option value="普通">普通</option>
                  <option value="不滿意">不滿意</option>
                  <option value="沒接觸">沒接觸</option>
                </select>
              </div>
            </div>
            <!-- 總結 -->
            <h3 style="text-align: center;">
              總結
            </h3>
            <br />
            <p>
              請您為本次就醫總體滿意度打一個分數
            </p>
            <br />
            <select v-model="survey['滿意度分數']">
              <option value="">請選擇下列選項</option>
              <option value="90以上">90以上</option>
              <option value="80-90分">80-90分</option>
              <option value="70-79分">70-79分</option>
              <option value="60分以下">60分以下</option>
            </select>
            <br />
            <p>呈上，如有不滿意的地方，歡迎給我們建議的做法。</p>
            <input
              v-model="survey['建議做法']"
              type="text"
              class="inputBox line"
            />
            <br />
            <br />
            <p>
              請問您是否願意推薦木生診所給您的親友？
            </p>
            <br />
            <select v-model="survey['是否推薦']">
              <option value="">請選擇下列選項</option>
              <option value="非常願意">非常願意</option>
              <option value="願意">願意</option>
              <option value="普通">普通</option>
              <option value="不願意">不願意</option>
              <option value="非常不願意">非常不願意</option>
            </select>
            <br />

            <br />
            <p>
              如您願意嘉獎某位工作人員，請填下他的姓名
            </p>
            <br />
            <input
              v-model="survey['嘉獎工作人員姓名']"
              type="text"
              class="inputBox line"
            />
            <br />
            <br />

            <p>如您希望投訴某位工作人員，請填下他的姓名</p>
            <br />
            <input
              v-model="survey['被投訴員工姓名']"
              type="text"
              class="inputBox line"
            />
            <br />
            <p>
              不滿意之描述
            </p>
            <br />
            <textarea
              v-model="survey['不滿意描述']"
              placeholder="訊息輸入"
            ></textarea>
            <br />
            <p>
              對於上述事項，如同意我們與您進一步聯絡，請留下聯絡方式
              請留下您的姓名與聯絡電話，專人會儘快與您聯絡，謝謝。
            </p>
            <br />
            <input
              v-model="survey['聯絡方式']"
              type="text"
              class="inputBox line"
            />

            <p style="display:inline;">
              您的入住日期為
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <br />
            <input
              v-model="survey['入住日期']"
              type="date"
              class="inputBox line"
            />
            <br />

            <br />
            <p style="display:inline;">
              本份問卷是由
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <br />
            <select v-model="survey['填寫人']">
              <option value="">請選擇下列選項</option>
              <option value="媽咪本人填寫">媽咪本人填寫</option>
              <option value="親友代填">親友代填</option>
            </select>
            <p style="color: #999999; text-align: justify;">
              問卷到此告一段落 : ) 再次感謝您的耐心分享，
              您的批評與指教是我們最寶貴的禮物。<br />
              木生全體醫護人員，在此向您鞠躬致謝。<br />
              祝願您擁有美好的一天！
            </p>
            <br />
            <input
              @click.prevent="submitForm"
              type="submit"
              class="submitBtn"
              value="確認送出"
            />
          </form>
        </div>
      </div>
    </div>
  </div>
  <modal v-if="modal.display" @close="closeModal">
    <template #header>{{ modal.header }}</template>
    <template #body>{{ modal.body }}</template>
  </modal>
</template>
<script>
import { reactive, ref } from "vue";
import { useRouter } from "vue-router";
const returnRouter = () => {
  const router = useRouter();

  const goTo = destination => {
    router.replace(destination);
  };
  return {
    goTo
  };
};
import store from "../../store/index.js";
import api from "../../api";
export default {
  setup() {
    const { goTo } = returnRouter();
    const survey = ref({
      滿意的地方: {},
      須改善的地方: {}
    });
    const modal = reactive({});
    const satisfactoinTitle = reactive([
      "診所環境與設施",
      "主治醫師醫療過程",
      "護理人員服務滿意度",
      "工作人員服務滿意度"
    ]);
    const satisfactoinQuestion = ref([
      [
        "病房環境設計",
        "空調冷暖適中",
        "病房光線適中",
        "床被單舒適清潔",
        "病房內個人隱私",
        "陪睡床舒適程度",
        "病房內浴廁清潔",
        "病房內備品完善",
        "餐飲膳食美味",
        "樓層指示圖易懂",
        "病房夜間安寧"
      ],
      [
        "醫師仔細診察與說明病情",
        "決定治療方式時，醫師有詳細說明並詢問病患/家屬的意見 ",
        "住院期間主治醫師會來巡視",
        "住院期間有需要找醫師時，醫師會來處理"
      ],

      [
        "護理人員對您的稱呼",
        "入院時的住院需知介紹",
        "點滴、抽血等專業技術",
        "打針或給藥時能說明作用及注意事項",
        "護理人員關懷您的感受",
        "護理人員尊重您的隱私",
        "當您需要幫忙時，護理人員能協助處理",
        "離院前教導出院衛教及注意事項"
      ],

      [
        "辦理出入院手續人員的服務態度",
        "護理人員的服務態度",
        "麻醉師的服務態度",
        "嬰兒室護理人員的服務態度",
        "產後哺餵母奶之護理指導",
        "病房清潔人員的服務態度",
        "送膳人員的服務態度",
        "警衛保全的服務態度"
      ]
    ]);

    function submitForm() {
      // let questionPass = [null, true, true, true];
      // questionPass.forEach((_, index) => {
      //   if (index === 0) {
      //     return;
      //   }
      //   satisfactoinQuestion.value[index].forEach(question => {
      //     questionPass[index] = questionPass[index] && survey.value[question];
      //   });
      // });

      // // [檢查項目,錯誤訊息]
      // const checkingList = [
      //   [survey.value.初次住院, "是否初次住院"],
      //   [survey.value.看診科別, "看診科別"],
      //   [survey.value.病房號碼, "病房號碼"],
      //   [questionPass[1], "主治醫師醫療過程"],
      //   [questionPass[2], "護理人員服務滿意度"],
      //   [questionPass[3], "工作人員服務滿意度"],
      //   [survey.value.入住日期, "入住日期"],
      //   [survey.value.填寫人, "填寫人"]
      // ];

      // // 檢查是否通過
      // let passChecking = true;
      // checkingList.forEach(item => {
      //   passChecking = passChecking && item[0];
      // });

      // // guard
      // if (!passChecking) {
      //   let bodyMessage = "請補足以下欄位：\n";
      //   checkingList.forEach(item => {
      //     if (item[0] === undefined || item[0] === false || item[0] === 0) {
      //       bodyMessage = bodyMessage + item[1] + "\n";
      //     }
      //   });
      //   Object.assign(modal, {
      //     display: true,
      //     header: "必填欄位缺失",
      //     body: bodyMessage
      //   });

      //   return;
      // }

      api.surveyForm
        .create({
          jwt: store.state.member.jwt,
          type: "病房部",
          data: survey.value
        })
        .then(data => {
          console.log(data);
          Object.assign(modal, {
            type: "success",
            display: true,
            header: "表單填寫成功",
            body: "感謝您的耐心填寫。"
          });
        })
        .catch(error => {
          Object.assign(modal, {
            type: "fail",
            display: true,
            header: "網路連線異常",
            body: error.message
          });
        });
    }

    function backHome() {
      goTo("/FeedBack");
    }

    function closeModal() {
      if (modal.type === "success" && store.state.from === "/FeedBack") {
        goTo("/Feedback");
        return;
      }
      modal.display = false;
    }

    return {
      backHome,
      survey,
      satisfactoinQuestion,
      submitForm,
      satisfactoinTitle,
      modal,
      closeModal
    };
  }
};
</script>
